import FleetReconciliationListView from "../../components/FleetReconciliationListView";

FleetReconciliationListScreen.propTypes = {};

function FleetReconciliationListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <FleetReconciliationListView />
            </div>
        </div>
    );
}

export default FleetReconciliationListScreen;
